module.exports = __webpack_public_path__ + "media/src/application/media/help_2-7901cc6a61dba52c62af9d1567ac9819.jpg";